<div class="modal-header justify-content-between">
  <h4 class="modal-title header-13">Map Generated Test Cases to Script</h4>
  <div class="d-flex">
    <span class="general-text-11 step-wrapper">{{ displayStep }}</span>
   <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="activeModal.dismiss('Cross click')"
    >
      <img
        [src]="
          isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'
        "
      />
    </button>
  </div>
</div>

<div class="modal-body w-100 d-flex flex-column">
  @if(displayLoader) {
  <app-loading class="m-auto" [text]="'Loading'"></app-loading>
  } @else {
  <div class="d-flex justify-content-between">
    <div class="search-container mb-2 d-flex">
      <input
        #searchBox
        type="text"
        placeholder="Search"
        class="search-input general-text-5"
        (input)="filteredTableData = onSearch(tableData, searchBox.value)"
      />

      <button class="search-button v-center">
        <i class="bi bi-search general-text-5"></i>
      </button>
    </div>

    <span *ngIf="displaySkip" class="skip"> Skip this step </span>
  </div>
  <app-zorro-table
    tableId="scr-map"
    (handleActions)="onRowHandle($event)"
    [data]="filteredTableData.length ? filteredTableData : tableData"
    [columns]="columns"
    [options]="{ expandable: true, stickyGroupRows: true }"
    [enableHorizontalScroll]="true"
    nzTableLayout="fixed"
  ></app-zorro-table>

  }
</div>
